import { render } from "./UjRendezvenysatorView.vue?vue&type=template&id=58a0f2a4"
import script from "./UjRendezvenysatorView.vue?vue&type=script&lang=js"
export * from "./UjRendezvenysatorView.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/mobil-maszofal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__